import { business } from '../../../shared/config/site';
import { PerimeterTile } from '../../services/components/PerimeterTile';

const { address } = business;

/**
 * The close. Phone first at display scale, then the address as a real
 * `<address>` element, then the one honest gap in the page: the hours.
 */
export function ContactBand() {
  return (
    <section id="contact" className="u-band u-defer bg-[color:var(--color-surface)]">
      <div className="u-shell grid gap-14 lg:grid-cols-[1.2fr_0.8fr] lg:gap-20">
        <div>
          <p className="u-label mb-6 text-[color:var(--steel-500)]">Contact</p>

          <h2 className="u-balance u-display max-w-[13ch] text-[clamp(1.75rem,3.6vw,3rem)] text-[color:var(--bone-50)]">
            Call for a quote
          </h2>

          <p className="u-measure mt-6 text-[color:var(--steel-400)]">
            Tell us the address and what needs covering.
          </p>

          <a
            href={business.telephoneHref}
            className="u-display mt-10 inline-flex items-center bg-[color:var(--signal-500)] px-8 py-5 text-[clamp(1.25rem,3.2vw,2rem)] text-[color:var(--ink-900)] transition-transform hover:scale-[1.015] active:scale-[0.99]"
            style={{ transitionDuration: 'var(--t-tap)', transitionTimingFunction: 'var(--e-settle)' }}
          >
            {business.telephoneDisplay}
          </a>
        </div>

        <div className="flex flex-col gap-8">
          <div className="u-rule pt-6">
            <p className="u-label mb-3 text-[color:var(--steel-500)]">Where we are</p>
            <address className="not-italic text-[color:var(--bone-100)]">
              {address.unit}, {address.street}
              <br />
              {address.suburb}, {address.city}
              <br />
              {address.region} {address.postalCode}
            </address>
            <a
              href={business.directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="u-label mt-4 inline-flex min-h-[44px] items-end border-b border-[color:var(--steel-600)] pb-1 text-[color:var(--steel-400)] transition-colors hover:border-[color:var(--bone-50)] hover:text-[color:var(--bone-50)]"
              style={{ transitionDuration: 'var(--t-state)', transitionTimingFunction: 'var(--e-settle)' }}
            >
              Get directions
            </a>
          </div>

          <div className="u-rule pt-6">
            <p className="u-label mb-3 text-[color:var(--steel-500)]">Hours</p>
            {/* Not published anywhere the research could reach. Labelled rather
                than guessed, and raised with the owner in the outreach note. */}
            <p className="text-[color:var(--steel-400)]">{business.hours.label}</p>
          </div>

          <div className="u-rule flex items-start justify-between gap-6 pt-6">
            <div>
              <p className="u-label mb-3 text-[color:var(--steel-500)]">Find us elsewhere</p>
              <ul className="flex flex-col gap-2">
                {business.socials.map((social) => (
                  <li key={social.label}>
                    <a
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex min-h-[44px] items-center border-b border-transparent text-[color:var(--bone-100)] transition-colors hover:border-[color:var(--signal-500)] hover:text-[color:var(--signal-400)]"
                      style={{
                        transitionDuration: 'var(--t-state)',
                        transitionTimingFunction: 'var(--e-settle)',
                      }}
                    >
                      {social.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="h-24 w-24 shrink-0 opacity-70">
              <PerimeterTile plan="gate" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
